export const DocumentKeys = {
	all: ["document"] as const,
	get allLists() {
		return [...this.all, "list"] as const;
	},
	list: (tag?: string) => [...DocumentKeys.allLists, { tag }] as const,
	get pinnable() {
		return [...this.allLists, "pinnable"] as const;
	},
	get saved() {
		return [...this.all, "saved"] as const;
	},
	download: (id: number) => [...DocumentKeys.all, "download", id] as const,
	get mutation() {
		return [...this.all, "mutation"] as const;
	},
	get transfer() {
		return [...this.all, "transfer"] as const;
	},
};
